export default function collectReducer(state, action) {
    if (!state) {
        state = [];
    }

    switch (action.type) {
        case 'COLLECT_EVENT':
            state = [...state, action.payload];
            break;
        case 'COLLECT_EVENTS_REPORTED':
            state = state.filter(occurrence => !action.ids.includes(occurrence.id));
            break;
    }

    return state;
}
